export default {
  headers: [
    {
      id: 'mainHeader',
      logo: {
        alt: 'kruger logo',
        src: 'https://si-homelight.s3.amazonaws.com/sites/murter/logo.png',
        url: 'https://krealestate.com',
      },
      breakpoint: 1024,
      desktopMenu: {
        type: 'split',
        disableOnHoverMenuExpand: true,
        logo: {
          show: true,
          reverseOrder: false,
          containerClassName: 'on-murter-desktop-header-logo-container',
          imageClassName: 'on-murter-desktop-header-logo',
        },
        headerClassName: 'on-murter-desktop-header',
        headerSectionsClassName: 'on-murter-desktop-header-section',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        itemClassName: 'on-murter-desktop-item',
        menuClassName: '',
        menuLabelActiveClassName: '',
        menuItemClassName: '',
        subMenuClassName: '',
        subMenuLabelActiveClassName: '',
        subMenuItemClassName: '',
        items: [
          {
            id: 'buy-item',
            url: 'https://search.krealestate.com/',
            className: null,
            content: 'BUY',
          },
          {
            id: 'sell-item',
            url: 'https://www.krealestate.com/home-valuation',
            content: 'SELL',
          },
          {
            id: 'team-item',
            url: 'https://www.krealestate.com/team',
            content: 'TEAM',
          },
          {
            id: 'testimonials-item',
            content: 'TESTIMONIALS',
            url: 'https://www.zillow.com/profile/JamesKrueger/#reviews',
          },
          {
            id: 'get-a-cash-offer-item',
            url: 'https://murter-cash-offer.netlify.app/',
            content: 'CASH OFFER',
          },
          {
            id: 'home-trade-in-item',
            url: 'https://pensive-babbage-336f8a.netlify.app/',
            content: 'HOME TRADE IN',
          },
          {
            id: 'blog-item',
            url: 'https://www.krealestate.com/blog',
            content: 'BLOG',
          },
          {
            id: 'portal-item',
            url: 'https://www.krealestate.info/',
            content: 'PORTAL',
          },
        ],
      },
      mobileMenu: {
        logo: {
          show: true,
          containerClassName: 'on-murter-mobile-header-logo-container',
          imageClassName: 'on-murter-mobile-header-logo',
        },
        type: 'mobile-default',
        menuOpener: {
          className: 'on-test',
          content: 'Open',
        },
        headerClassName: 'on-murter-mobile-header',
        headerClassNameOverride: '',
        mobileMenuClassName: 'on-murter-mobile-header-menu',
        itemClassName: 'on-murter-mobile-item',
        menuClassName: '',
        menuLabelActiveClassName: '',
        menuItemClassName: '',
        subMenuClassName: '',
        subMenuItemClassName: '',
        headerItems: [],
        items: [
          {
            id: 'portal-item',
            url: 'https://www.krealestate.info',
            className: null,
            content: 'PORTAL',
          },
          {
            id: 'buy-item',
            url: 'https://search.krealestate.com',
            content: 'BUY',
          },
          {
            id: 'sell-item',
            url: 'https://www.krealestate.com/home-valuation',
            content: 'SELL',
          },
          {
            id: 'team-item',
            url: 'https://www.krealestate.com/team',
            content: 'TEAM',
          },
          {
            id: 'testimonials-item',
            url: 'https://www.zillow.com/profile/JamesKrueger/#reviews',
            content: 'TESTIMONIALS',
          },
          {
            id: 'cash-offer-item',
            url: 'https://murter-cash-offer.netlify.app',
            content: 'CASH OFFER',
          },
          {
            id: 'home-trade-in-item',
            url: 'https://pensive-babbage-336f8a.netlify.app/',
            content: 'HOME TRADE IN',
          },
          {
            id: 'blog-item',
            url: 'https://www.krealestate.com/blog',
            content: 'BLOG',
          },
        ],
      },
    },
  ],
  footers: [
    {
      id: 0,
      display: true,
      className: 'on-murter-footer-section-first d-sm-block d-md-block d-lg-block d-xl-flex between-xl',
      sectionClassName: '',
      columns: [
        {
          id: 0,
          className: 'col-xl-4',
          style: {},
          items: [
            {
              id: 0,
              type: 'image',
              className: '',
              alt: 'img',
              style: { width: '270px' },
              url: 'https://si-homelight.s3.amazonaws.com/sites/murter/logo.png',
            },
            {
              id: 1,
              type: 'heading',
              className: 'pt-5 mt-2 ps-1',
              style: {},
              data: 'Copyright © 2022 All rights reserved.',
            },
          ],
        },
        {
          id: 1,
          className: 'col-xl-4 ps-1',
          style: {},
          items: [
            {
              id: 0,
              type: 'heading',
              elementType: 'h1',
              className: 'on-murter-footer-heading mt-2 mt-xl-0 pt-sm-5 pt-md-5 pt-lg-5 pt-xl-1',
              style: {},
              data: 'GET IN TOUCH',
            },
            {
              id: 1,
              type: 'list',
              className: 'on-murter-footer-list',
              rowClassName: 'on-murter-footer-list-row',
              style: {},
              items: [
                {
                  id: 0,
                  data: [
                    {
                      style: { fontSize: '15px' },
                      text: 'Visit',
                    },
                    {
                      text: '3320 Jackson Street Houston, TX, 77004',
                    },
                  ],
                },
                {
                  id: 1,
                  data: [
                    {
                      style: { fontSize: '15px' },
                      text: 'Call',
                    },
                    {
                      text: '(713) 364-4003',
                      url: 'tel:(713)3644003',
                    },
                  ],
                },
                {
                  id: 2,
                  data: [
                    {
                      style: { fontSize: '15px' },
                      text: 'Email',
                    },
                    {
                      text: 'hello@krealestate.com',
                      url: 'mailto:hello@krealestate.com',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 2,
          className: 'col-xl-4 ps-1',
          style: {},
          items: [
            {
              id: 0,
              type: 'heading',
              elementType: 'h1',
              className: 'on-murter-footer-heading mt-2 mt-xl-0 pt-sm-5 pt-md-5 pt-lg-5 pt-xl-1 ',
              style: {},
              data: 'STAY CONNECTED',
            },
            {
              id: 1,
              type: 'list',
              className: 'on-murter-footer-list',
              rowClassName: 'on-murter-footer-list-row',
              style: {},
              items: [
                {
                  id: 0,
                  data: [
                    {
                      id: 0,
                      style: { fontSize: '15px' },
                      text: 'Facebook',
                    },
                    {
                      id: 1,
                      text: 'facebook.com/KruegerRealEstate',
                      url: 'https://facebook.com/KruegerRealEstate',
                    },
                  ],
                },
                {
                  id: 1,
                  data: [
                    {
                      id: 0,
                      style: { fontSize: '15px' },
                      text: 'Instagram',
                    },
                    {
                      id: 1,
                      text: 'instagram.com/krealestate_/',
                      url: 'https://instagram.com/krealestate_/',
                    },
                  ],
                },
                {
                  id: 2,
                  data: [
                    {
                      id: 0,
                      style: { fontSize: '15px' },
                      text: 'Twitter',
                    },
                    {
                      id: 1,
                      text: 'twitter.com/krealestate_',
                      url: 'https://twitter.com/krealestate_',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 1,
      display: true,
      className: 'on-murter-footer-section-last ps-1',
      columns: [
        {
          id: 0,
          className: 'mt-2 mt-xl-0 ps-lg-1 pt-md-5 pt-sm-5 pt-lg-5',
          style: {},
          items: [
            {
              id: 0,
              type: 'heading',
              elementType: 'h1',
              className: 'on-murter-footer-heading pt-5',
              style: {},
              data: 'PRIVACY POLICY',
            },
            {
              id: 1,
              type: 'heading',
              className: 'on-murter-footer-text',
              elementType: 'p',
              style: {},
              data: 'All information provided by the listing agent/broker is deemed reliable but is not guaranteed and should be independently verified.',
            },
          ],
        },
      ],
    },
  ],
  substitute: {},
  replace: {
    'tradeIn.hero.agent.showPhoto': 'showAgentPhoto',
    'cashOffer.hero.agent.showPhoto': 'showAgentPhoto',
  },
  siteData: {
    agency: 'Krueger Real Estate',
    agentName: 'James Krueger',
    agentDescription: 'Top agents in Houston, TX',
    agentAvatar: 'https://si-homelight.s3.amazonaws.com/sites/murter/agent.png',
    heroBackground: 'https://si-homelight.s3.amazonaws.com/sites/murter/hero-bg.jpg',
    showAgentPhoto: false,
  },
};
